import { forwardRef } from 'react';
import classNames from 'classnames';
import { VariantType } from './constants';
import { Icon } from '../Icon';
import { ComponentSize } from '../common/constants';
import ReactLoading from 'react-loading';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const Button = /*#__PURE__*/forwardRef(({
  children,
  className,
  size,
  variant,
  disabled,
  fullWidth,
  onClick,
  style,
  type,
  icon,
  iconPosition,
  href,
  target,
  loading,
  ...rest
}, ref) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: variant !== VariantType.LINK ? /*#__PURE__*/_jsx("button", {
      ref: ref,
      type: type,
      style: style,
      onClick: onClick,
      disabled: disabled || loading,
      className: classNames('frontino-button', className, size && `frontino-button--${size}`, icon && 'frontino-button--with-icon', variant && `frontino-button--${variant}`, fullWidth && 'frontino-button--full-width'),
      ...rest,
      children: /*#__PURE__*/_jsxs("span", {
        className: 'frontino-button__content' + (iconPosition ? ` frontino-button__content--${iconPosition}` : ""),
        children: [icon && /*#__PURE__*/_jsx(Icon, {
          className: 'frontino-button__icon' + (iconPosition ? ` frontino-button__icon--${iconPosition}` : ""),
          children: icon
        }), loading && /*#__PURE__*/_jsx(ReactLoading, {
          className: "frontino-button__content--loading",
          type: "spin",
          color: "#0a1437",
          height: "20px",
          width: "20px"
        }), children]
      })
    }) : /*#__PURE__*/_jsx("a", {
      className: classNames('frontino-button', className, (disabled || loading) && 'frontino-button--disabled', size && `frontino-button--${size}`, icon && 'frontino-button--with-icon', variant && `frontino-button--${variant}`, fullWidth && 'frontino-button--full-width'),
      href: href,
      target: target,
      style: style,
      children: /*#__PURE__*/_jsxs("span", {
        className: 'frontino-button__content' + (iconPosition ? ` frontino-button__content--${iconPosition}` : ""),
        children: [icon && /*#__PURE__*/_jsx(Icon, {
          className: 'frontino-button__icon' + (iconPosition ? ` frontino-button__icon--${iconPosition}` : ""),
          children: icon
        }), children]
      })
    })
  });
});
Button.frontinoName = 'FrontinoButton';
Button.defaultProps = {
  variant: VariantType.PRIMARY,
  size: ComponentSize.MEDIUM
};